import React, { useEffect, useMemo, useRef, useState } from "react";
import DynamicComponentsRenderer from "../../../unicomponents/formComponents/DynamicComponentsRenderer";
import LeftMenuSidebar from "../../../unicomponents/LeftMenuSidebar";
import { useReactToPrint } from "react-to-print";
import { generateRegistrationRows } from "../../../util/dealingArrObj";
import { useUIContext } from "../../../context/UIContext";
import useRegistrationInfo from "../../../hooks/useRegistrationInfo";
import useOrganizationSetting from "../../../hooks/useOrganizationSetting";
import useComponentsToForms from "../../../hooks/useComponentsToForms";
import useAllForms from "../../../hooks/useAllForms";
import { useLocation } from "react-router-dom";
import FiltersBar from "../../../unicomponents/Dropdowns/FilterBar";
import RightControlSidebar from "../../../unicomponents/RightControlSidebar";
import useTermPeriod from "../../../hooks/useTermPeriod";
import { setTermIdByToday } from "../../../util/dateRelated";
import { useTranslation } from "react-i18next";
import useUsers from "../../../hooks/useUsers";
import { useAuthContext } from "../../../context/AuthContext";
import useTeacherInfo from "../../../hooks/useTeacherInfo";
import useCertificateHistory from "../../../hooks/useCertificateHistory";
import { dateToYearMonthDayFormat } from "../../../util/formatdate";
import styles from "./css/OfficialDocuments.module.css";
import useFlexibleData from "../../../hooks/useFlexibleData";
import useStudentInfo from "../../../hooks/useStudentInfo";

export default function OfficialDocuments() {
  const { t } = useTranslation();
  const location = useLocation();
  const paths = location.pathname.split("/");
  const schoolId = paths[1];
  const [filters, setFilters] = useState({
    schoolYear: null,
    schoolYearId: "",
    hierarchyOneId: "",
    hierarchyTwoId: "",
    hierarchyThreeId: "",
    organPathForSort: "/",
    termId: "",
    selectedTeacherId: "",
    selectedLessonId: "",
  });

  const [termId, setTermId] = useState("");
  const [currentPeriod, setCurrentPeriod] = useState({});
  const [studentList, setStudentList] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [searchKeyStudent, setSearchKeyStudent] = useState("");

  const [selectedStudentList, setSelectedStudentList] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState({});

  const [teacherList, setTeacherList] = useState([]);
  const [selectedTeacherList, setSelectedTeacherList] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState({});
  const [noPermission, setNoPermission] = useState(false);
  const [keyData, setKeyData] = useState({});
  // const [validateInput, setValidateInput] = useState({});
  const [modifyMode, setModifyMode] = useState(false);
  const [interComponentData, setInterComponentData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [beforePrint, setBeforePrint] = useState(false);

  const [activeMenu, setActiveMenu] = useState({
    menu_name: "",
    menu_id: "",
  });

  const conditions = {
    schoolid: schoolId,
    form_category: "officialDocuments",
  };

  const [formQueryConditions, setFormQueryConditions] = useState({
    schoolid: schoolId,
    form_id: "",
  });

  const [styleSettings, setStyleSettings] = useState({});

  const {
    allFormsQuery: { data: allFormsData },
  } = useAllForms(conditions);

  const {
    componentsToFormsQuery: { data: componentsToFormsData = [], isLoading },
  } = useComponentsToForms(formQueryConditions);

  /** 졸업증명서 행의 customized_contents (과정선택 '전체' 허용 여부 등) */
  const graduationCertificateCustomContents = useMemo(() => {
    if (!Array.isArray(componentsToFormsData)) return {};
    const row = componentsToFormsData.find((item) => {
      const name = item?.components?.component_filename;
      return (
        name === "GraduationCertificate.jsx" ||
        (typeof name === "string" && name.includes("GraduationCertificate"))
      );
    });
    const c = row?.customized_contents;
    return c && typeof c === "object" ? c : {};
  }, [componentsToFormsData]);

  const {
    settingQuery: { data: settingData },
  } = useOrganizationSetting({ schoolid: schoolId });

  const {
    termPeriodQuery: { data: termPeriodData },
  } = useTermPeriod({ schoolid: schoolId });

  const {
    registrationInfoQuery: { data: registrationInfoData },
  } = useRegistrationInfo({ schoolid: schoolId });

  //교직원용
  const {
    usersQuery: { data: userData },
  } = useUsers({ schoolid: schoolId, role: "teacher", status: 1 });

  const { findTeacherInfo } = useTeacherInfo();

  const findTeacherInfoRef = useRef(findTeacherInfo);

  const { findStudentInfo } = useStudentInfo();

  const findStudentInfoRef = useRef(findStudentInfo);

  const {
    createCertificateHistory,
    updateCertificateHistory,
    deleteCertificateHistory,
  } = useCertificateHistory();

  const {
    flexibleDataQuery: { data: flexibleData },
  } = useFlexibleData({
    schoolid: schoolId,
    main_category: "certificateTeacherAuthority",
  });

  const { user } = useAuthContext();

  const { setIsLoadingModal, handleToastCenterTop, handleToastCenterBottom } =
    useUIContext();

  const { hasPermission } = useAuthContext();

  useEffect(() => {
    if (activeMenu?.menu_name !== "graduationCertificate") return;
    if (interComponentData?.schoolStage !== "all") return;
    if (graduationCertificateCustomContents?.schoolStageAll) return;
    setInterComponentData((prev) => ({ ...prev, schoolStage: "" }));
  }, [
    activeMenu?.menu_name,
    graduationCertificateCustomContents?.schoolStageAll,
    interComponentData?.schoolStage,
  ]);

  const handleSearch = (e) => {
    const { value } = e.target;

    if (activeMenu?.description === "teacher") {
      setSearchKey(value);
      if (value === "") {
        setSelectedTeacherList([]);
      } else if (teacherList) {
        const filteredRows = teacherList.filter((row) =>
          row.fullname.includes(value),
        );

        // 고유한 username을 기준으로 중복 제거
        const uniqueFilteredRows = Array.from(
          new Map(filteredRows.map((item) => [item.username, item])).values(),
        );

        // 고유한 항목으로 setUsernameList 업데이트
        setSelectedTeacherList(uniqueFilteredRows);
      }
    } else if (activeMenu?.description === "student") {
      setSearchKeyStudent(value);

      if (registrationInfoData) {
        const filteredRows = registrationInfoData.filter((row) =>
          row.user?.fullname?.includes(value),
        );

        const uniqueFilteredRows = Array.from(
          new Map(filteredRows.map((item) => [item.username, item])).values(),
        );

        // 고유한 항목으로 setUsernameList 업데이트
        setSelectedStudentList(uniqueFilteredRows);
      }
    }
  };

  const handleSelectTeacherUsername = (e) => {
    const { value } = e.target;
    // console.log("value", value);
    if (activeMenu?.description === "teacher") {
      findTeacherInfoRef.current.mutate(
        { username: value, schoolid: schoolId },
        {
          onSuccess: (data) => {
            setSelectedTeacher(data);
            setKeyData(data);
          },
          onError: (error) => {
            console.error(error);
            alert(t("common.messages.errorAlert") + error.message);
          },
        },
      );
    }
  };

  const handleSelectStudentUsername = (e) => {
    const { value } = e.target;
    // console.log("value", value);
    if (activeMenu?.description === "student") {
      findStudentInfoRef.current.mutate(
        { username: value, schoolid: schoolId },
        {
          onSuccess: (data) => {
            setSelectedStudent(data);
            setKeyData(data);
          },
          onError: (error) => {
            console.error(error);
            alert(t("common.messages.errorAlert") + error.message);
          },
        },
      );
    }
  };

  useEffect(() => {
    if (userData && user && activeMenu?.description === "teacher") {
      // 학생 관련 상태 리셋
      setSelectedStudent({});
      setSelectedStudentList([]);
      setSearchKeyStudent("");

      if (
        hasPermission(null, "can_delete") &&
        ((flexibleData &&
          flexibleData.length > 0 &&
          flexibleData[0]?.data_value?.hidden) ||
          user?.role === "admin")
      ) {
        setTeacherList(userData);
        setNoPermission(false);
        // 관리자 권한이면 교사 관련 상태 초기화
        setSelectedTeacher({});
        setSelectedTeacherList([]);
        setSearchKey("");
        setKeyData({});
      } else {
        const filteredData = userData.filter(
          (item) => item.username === user?.username,
        );
        setTeacherList(filteredData);
        setSelectedTeacherList(filteredData);

        findTeacherInfoRef.current.mutate(
          { username: user?.username, schoolid: schoolId },
          {
            onSuccess: (data) => {
              setSelectedTeacher(data);
              setKeyData(data);
            },
            onError: (error) => {
              console.error(error);
              alert(t("common.messages.errorAlert") + error.message);
            },
          },
        );
        setSearchKey(filteredData[0]?.fullname || "");
        setNoPermission(true);
      }
      // 증명서 발급 관련 데이터 리셋
      setInterComponentData({});
      setBeforePrint(false);
      setDisabled(false);
    } else if (activeMenu?.description === "student") {
      // 교사 관련 상태 리셋
      setTeacherList([]);
      setSelectedTeacher({});
      setSelectedTeacherList([]);
      setSearchKey("");
      setKeyData({});

      // 학생 증명서의 경우 기본적으로 권한 허용
      setNoPermission(false);

      // 증명서 발급 관련 데이터 리셋
      setInterComponentData({});
      setBeforePrint(false);
      setDisabled(false);
    } else if (activeMenu?.description) {
      // 교사 및 학생 관련 상태 모두 리셋
      setTeacherList([]);
      setSelectedTeacher({});
      setSelectedTeacherList([]);
      setSearchKey("");
      setSelectedStudent({});
      setSelectedStudentList([]);
      setSearchKeyStudent("");
      setKeyData({});

      // 기타 메뉴의 경우도 권한 허용
      setNoPermission(false);

      // 증명서 발급 관련 데이터 리셋
      setInterComponentData({});
      setBeforePrint(false);
      setDisabled(false);
    }
  }, [
    activeMenu?.description,
    findTeacherInfoRef,
    flexibleData,
    hasPermission,
    schoolId,
    t,
    user,
    userData,
  ]);

  useEffect(() => {
    if (allFormsData) {
      setFormQueryConditions((prev) => ({
        ...prev,
        form_id: allFormsData[0].id,
      }));

      setActiveMenu({
        menu_name: allFormsData[0].form_name,
        menu_id: allFormsData[0].id,
        description: allFormsData[0].description,
        form_label: allFormsData[0].form_label,
      });

      setStyleSettings(allFormsData[0]?.options || {});
    }
  }, [allFormsData]);

  useEffect(() => {
    let initialSchoolYear = null;
    let initialSchoolYearId = null;

    if (
      filters.schoolYear === null &&
      settingData &&
      settingData.length > 0 &&
      registrationInfoData
    ) {
      const initialData = settingData.sort(
        (a, b) => b.school_year - a.school_year,
      )[0];

      initialSchoolYear = initialData.school_year;
      initialSchoolYearId = initialData.id;
      setFilters((filters) => ({
        ...filters,
        schoolYear: initialSchoolYear,
        schoolYearId: initialSchoolYearId,
      }));

      if (termPeriodData) {
        setTermIdByToday(termPeriodData, setTermId, initialSchoolYearId);
      }

      //학생 리스트
      if (initialSchoolYear) {
        const sortedRows = generateRegistrationRows(
          registrationInfoData,
          settingData,
          initialSchoolYear,
          filters.organPathForSort,
        );

        setStudentList(sortedRows);
      }
    } else {
      //rows 데이터처리
      if (registrationInfoData && settingData) {
        // console.log("registrationInfoData", registrationInfoData);
        // console.log("filters", filters);

        const sortedRows = generateRegistrationRows(
          registrationInfoData,
          settingData,
          filters.schoolYear,
          filters.organPathForSort,
        );
        setStudentList(sortedRows);
      }
    }
  }, [
    filters,
    filters.schoolYear,
    registrationInfoData,
    settingData,
    termPeriodData,
  ]);

  useEffect(() => {
    if (termPeriodData) {
      const nowPeriod = termPeriodData.filter(
        (r) => r.id.toString() === termId.toString(),
      )[0];

      if (nowPeriod) {
        // console.log("nowPeriod", nowPeriod);
        setCurrentPeriod(nowPeriod);
      } else {
        setCurrentPeriod({});
      }
    }
  }, [termId, termPeriodData]);

  useEffect(() => {
    if (studentList && filters.selectedStudent) {
      const selectedObject = studentList.find(
        (r) => r.username === filters.selectedStudent,
      );
      if (currentPeriod && Object.keys(currentPeriod).length > 0) {
        setKeyData({
          ...selectedObject,
          currentPeriod: currentPeriod,
        });
      } else {
        setKeyData(selectedObject);
      }
    } else {
      setKeyData({});
    }
  }, [currentPeriod, filters.selectedStudent, schoolId, studentList]);

  const handleQueryCondition = (item) => {
    if (item?.id) {
      setFormQueryConditions((prev) => ({
        ...prev,
        form_id: item.id,
      }));

      setStyleSettings(item.options || {});
    }
    setModifyMode(false);
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;
    const dataName = e.target.selectedOptions[0].getAttribute("data-name");
    let organPath = "";
    if (!dataName) {
      organPath = "N/A";
    } else {
      organPath = dataName + "/" + value;
    }
    if (name === "0") {
      setFilters((filters) => ({
        ...filters,
        schoolYear: selectedOptionText,
        schoolYearId: value,
        hierarchyOneId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));

      setTermIdByToday(termPeriodData, setTermId, value);
    }

    if (name === "1") {
      setFilters((filters) => ({
        ...filters,
        hierarchyOneId: value,
        hierarchyTwoId: "",
        hierarchyThreeId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));

      setTermIdByToday(termPeriodData, setTermId, filters.schoolYearId, value);
    }

    if (name === "2") {
      setFilters((filters) => ({
        ...filters,
        hierarchyTwoId: value,
        hierarchyThreeId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));

      setTermIdByToday(
        termPeriodData,
        setTermId,
        filters.schoolYearId,
        filters.hierarchyOneId,
        value,
      );
    }

    if (name === "3") {
      setFilters((filters) => ({
        ...filters,
        hierarchyThreeId: value,
        organPathForSort: organPath,
        selectedStudent: "",
      }));
    }

    if (name === "students") {
      setFilters((filters) => ({
        ...filters,
        selectedStudent: value,
      }));
    }

    if (name === "termDate") {
      setTermId(value);
    }
  };

  const handleModifyMode = (e) => {
    e.preventDefault();

    if (
      keyData.school_year &&
      keyData[1] &&
      keyData[2] &&
      keyData[3] &&
      keyData.currentPeriod?.term_name &&
      keyData.fullname
    ) {
      const onOff = e.target.name;
      if (onOff === "modifyOn") {
        setModifyMode(false);
      } else {
        setModifyMode(true);
        handleToastCenterBottom(
          t("teacher.printingRelated.officialDocumentToastStyle"),
          4000,
        );
      }
    } else {
      console.log(
        "keyData is incomplete. Please ensure all data is available.",
      );
      handleToastCenterTop(t("teacher.printingRelated.canModifyAfterSelect"));
    }
  };

  const triggerPrint = useReactToPrint({
    content: () => {
      // addPageNumbers();
      return contentToPrint.current;
    },
    documentTitle:
      activeMenu?.description === "teacher" ||
      activeMenu?.description === "student"
        ? `${activeMenu?.form_label}-${keyData?.fullname}`
        : `${activeMenu?.form_label}-${keyData?.school_year}-${keyData?.currentPeriod?.term_name}-${keyData[1]}-${keyData[2]}-${keyData[3]}-${keyData.fullname}`,
    onBeforePrint: () => {
      console.log("before printing...");
    },
    onAfterPrint: () => {
      console.log("after printing...");
    },
    removeAfterPrint: true,
    pageStyle: `@media print {
      .noPrint {
          display: none !important;
        }
      @page {
        size: A4;
        margin: 10mm;
      }


    }`,
  });

  const contentToPrint = useRef(null);
  const handlePrint = () => {
    // console.log("keyData", keyData);

    if (
      (activeMenu?.description === "teacher" && keyData?.fullname) ||
      (activeMenu?.description === "student" && keyData?.fullname)
    ) {
      handleUpdateCertificateHistory();
      triggerPrint();
      return;
    }

    if (
      keyData.school_year &&
      keyData[1] &&
      keyData[2] &&
      keyData[3] &&
      keyData.fullname
    ) {
      triggerPrint();
    } else {
      console.log(
        "keyData is incomplete. Please ensure all data is available.",
      );
      handleToastCenterTop(t("common.messages.printAfterSelectStudent"));
    }
  };

  const handleStyleSettings = (e) => {
    const { name, value, classList } = e.target;
    setStyleSettings((prev) => {
      // 글씨체 변경 처리 (classList에 'fontFamily' 포함된 경우)
      if (classList.contains("fontFamily")) {
        return {
          ...prev,
          fontFamily: value,
        };
      }

      // 폰트 크기 변경 처리 (classList에 'fontSizes' 포함된 경우)
      if (classList.contains("fontSizes")) {
        const updatedFontSizes = prev.fontSizes.map((option) =>
          option.name === name ? { ...option, value } : option,
        );

        return {
          ...prev,
          fontSizes: updatedFontSizes,
        };
      }

      // 기본적으로 이전 상태를 반환
      return prev;
    });
  };

  //증명서 발급 이력 생성
  const handleCreateCertificateHistory = () => {
    if (!keyData?.fullname || !keyData?.username) {
      handleToastCenterTop("대상을 먼저 선택해 주세요.");
      return;
    }

    if (activeMenu?.description === "teacher") {
      if (
        !interComponentData?.entranceDate &&
        activeMenu?.menu_name === "employmentCertificate"
      ) {
        handleToastCenterTop(
          t("admin.certificate.noEntranceDate") ||
            "교직원 정보에 입사일 기록이 없다면 재직증명서를 발급할 수 없습니다.",
        );
        return;
      }

      if (
        interComponentData?.terminationDate &&
        activeMenu?.menu_name === "employmentCertificate"
      ) {
        handleToastCenterTop(
          t("admin.certificate.alreadyTerminated") ||
            "퇴직한 교직원은 재직증명서를 발급할 수 없습니다.",
        );
        return;
      }
    } else if (activeMenu?.description === "student") {
      if (
        !interComponentData?.entranceDate &&
        activeMenu?.menu_name === "enrollmentCertificate"
      ) {
        handleToastCenterTop(
          t("admin.certificate.noEnrollmentDate") ||
            "학생 정보에 입학일 기록이 없다면 재학증명서를 발급할 수 없습니다.",
        );
        return;
      }

      if (
        (interComponentData?.terminationDate ||
          (interComponentData?.enrollment_status &&
            interComponentData.enrollment_status !== "재학중")) &&
        activeMenu?.menu_name === "enrollmentCertificate"
      ) {
        handleToastCenterTop(
          t("admin.certificate.alreadyTerminatedStudent") ||
            "재학 중이 아닌 학생은 재학증명서를 발급할 수 없습니다.",
        );
        return;
      }

      if (
        activeMenu?.menu_name === "graduationCertificate" &&
        interComponentData?.canIssueGraduationCertificate !== true
      ) {
        const reasons =
          interComponentData?.graduationCertificateMissingReasons;
        const msg =
          Array.isArray(reasons) && reasons.length > 0
            ? `${reasons.join(" ")} 졸업증명서를 발급할 수 없습니다.`
            : "졸업증명서를 발급할 수 없습니다.";
        handleToastCenterTop(msg);
        return;
      }
    }

    setDisabled(true);
    setIsLoadingModal(true);
    setBeforePrint(true);
    setInterComponentData((prev) => ({
      ...prev,
      beforePrint: true,
    }));

    const certificateHistory = {
      schoolid: schoolId,
      certificate_type: activeMenu?.menu_name,
      subject_type: activeMenu?.description,
      subject_username: keyData?.username,
      request_date: dateToYearMonthDayFormat(new Date()),
      issuer: user?.username,
      purpose: interComponentData?.purpose || "",
      snapshot: interComponentData?.snapshot,
      ...(interComponentData?.certificateNoTitle && {
        certificateNoTitle: interComponentData.certificateNoTitle,
      }),
    };

    createCertificateHistory.mutate(certificateHistory, {
      onSuccess: (certificateData) => {
        setInterComponentData((prev) => ({
          ...prev,
          certificate_no: certificateData?.certificate_no || "",
          certificate_id: certificateData?.id || "",
        }));
        setTimeout(() => {
          setDisabled(false);
          setIsLoadingModal(false);
        }, 1000);
      },
      onError: (error) => {
        console.error("Error creating certificateHistory:", error);
        setDisabled(false);
        setIsLoadingModal(false);
      },
    });
  };

  //증명서 이력 업데이트
  const handleUpdateCertificateHistory = () => {
    if (!interComponentData?.certificate_id) {
      handleToastCenterTop(
        t("admin.certificate.noRequest") ||
          "발급신청한 것이 없습니다. 새로고침 후 발급신청을 먼저 해주세요.",
      );
      return;
    }

    setDisabled(true);
    setIsLoadingModal(true);

    const certificateHistory = {
      id: interComponentData?.certificate_id,
      status: "completed",
    };

    updateCertificateHistory.mutate(certificateHistory, {
      onSuccess: () => {
        setTimeout(() => {
          setDisabled(false);
          setIsLoadingModal(false);
          setBeforePrint(false);

          if (activeMenu?.description === "teacher") {
            if (
              hasPermission(null, "can_delete") &&
              ((flexibleData &&
                flexibleData.length > 0 &&
                flexibleData[0]?.data_value?.hidden) ||
                user?.role === "admin")
            ) {
              setInterComponentData({});
              setKeyData({});
              setSelectedTeacher({});
              setSelectedTeacherList([]);
              setSearchKey("");
            } else {
              const filteredData = userData.filter(
                (item) => item.username === user?.username,
              );

              setInterComponentData({});
              setKeyData({});
              setSelectedTeacher({});
              setSelectedTeacherList([]);
              setSearchKey("");

              setTeacherList(filteredData);
              setSelectedTeacherList(filteredData);

              findTeacherInfoRef.current.mutate(
                { username: user?.username, schoolid: schoolId },
                {
                  onSuccess: (data) => {
                    setSelectedTeacher(data);
                    setKeyData(data);
                  },
                  onError: (error) => {
                    console.error(error);
                    alert(t("common.messages.errorAlert") + error.message);
                  },
                },
              );
              setSearchKey(filteredData[0]?.fullname || "");
              setNoPermission(true);
            }
          } else if (activeMenu?.description === "student") {
          }
          setInterComponentData({});
          setKeyData({});
          setSelectedStudent({});
          setSelectedStudentList([]);
          setSearchKeyStudent("");
        }, 3000);
      },
      onError: (error) => {
        console.error(error);
        setDisabled(false);
        setIsLoadingModal(false);
        handleToastCenterTop(t("common.messages.errorAlert") + error.message);
      },
    });
  };

  //증명서 이력 삭제
  const handleDeleteCertificateHistory = () => {
    if (!interComponentData?.certificate_id) {
      handleToastCenterTop("발급이력이 없습니다.");
      return;
    }

    setDisabled(true);
    setIsLoadingModal(true);

    deleteCertificateHistory.mutate(interComponentData?.certificate_id, {
      onSuccess: () => {
        setTimeout(() => {
          setDisabled(false);
          setIsLoadingModal(false);
          setBeforePrint(false);

          if (activeMenu?.description === "teacher") {
            if (
              hasPermission(null, "can_delete") &&
              ((flexibleData &&
                flexibleData.length > 0 &&
                flexibleData[0]?.data_value?.hidden) ||
                user?.role === "admin")
            ) {
              setInterComponentData({});
              setKeyData({});
              setSelectedTeacher({});
              setSelectedTeacherList([]);
              setSearchKey("");
            } else {
              const filteredData = userData.filter(
                (item) => item.username === user?.username,
              );

              setTeacherList(filteredData);
              setSelectedTeacherList(filteredData);

              findTeacherInfoRef.current.mutate(
                { username: user?.username, schoolid: schoolId },
                {
                  onSuccess: (data) => {
                    setSelectedTeacher(data);
                    setKeyData(data);
                  },
                  onError: (error) => {
                    console.error(error);
                    alert(t("common.messages.errorAlert") + error.message);
                  },
                },
              );
              setSearchKey(filteredData[0]?.fullname || "");
              setNoPermission(true);
            }
          } else if (activeMenu?.description === "student") {
            setInterComponentData({});
            setKeyData({});
            setSelectedStudent({});
            setSelectedStudentList([]);
            setSearchKeyStudent("");
          }
        }, 1000);
      },
      onError: (error) => {
        console.error(error);
        setDisabled(false);
        setIsLoadingModal(false);
        handleToastCenterTop(t("common.messages.errorAlert") + error.message);
      },
    });
  };

const handleSelectSchoolStage = (e) => {
  setInterComponentData((prev) => ({
    ...prev,
    schoolStage: e.target.value,
  }));
};


  return (
    <div className="basicWidth">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-2">
            <LeftMenuSidebar
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              menuData={allFormsData}
              extraFunction={handleQueryCondition}
              itemName="form_name"
              itemLabel="form_label"
            />
          </div>
          <div className={`col-12 col-md-${modifyMode ? "8" : "10"}`}>
            <div className="d-flex justify-content-end flex-wrap mt-2">
              {activeMenu?.description === "teacher" ? (
                <>
                  <div>
                    <label>{t("common.user.faculty") || "교직원"}</label>
                    <input
                      type="text"
                      id="searchKeyword"
                      name="searchKeyword"
                      className="form-control"
                      placeholder={t("common.user.faculty") || "교직원"}
                      value={searchKey}
                      onChange={handleSearch}
                      disabled={noPermission || beforePrint}
                    />
                  </div>
                  <div className="ms-3">
                    <label>{t("common.user.faculty") || "교직원"} ID</label>
                    <select
                      className="form-control"
                      name="username"
                      onChange={handleSelectTeacherUsername}
                      value={selectedTeacher?.username || ""}
                      disabled={noPermission || beforePrint}
                    >
                      <option value="">
                        {t("teacher.printingRelated.selectUsername")}
                      </option>
                      {selectedTeacherList &&
                        selectedTeacherList.map((user) => (
                          <option key={user.id} value={user.username}>
                            {user.username}
                          </option>
                        ))}
                    </select>
                  </div>
                </>
              ) : activeMenu?.description === "student" ? (
                <>
                  <div>
                    <label>{t("common.user.student") || "학생"}</label>
                    <input
                      type="text"
                      id="searchKeyword"
                      name="searchKeyword"
                      className="form-control"
                      placeholder={t("common.user.student") || "학생"}
                      value={searchKeyStudent || ""}
                      onChange={handleSearch}
                      disabled={noPermission || beforePrint}
                    />
                  </div>
                  <div className="ms-3">
                    <label>{t("common.user.student") || "학생"} ID</label>
                    <select
                      className="form-control"
                      name="username"
                      onChange={handleSelectStudentUsername}
                      value={selectedStudent?.username || ""}
                      disabled={noPermission || beforePrint}
                    >
                      <option value="">
                        {t("teacher.printingRelated.selectUsername")}
                      </option>
                      {selectedStudentList &&
                        selectedStudentList.map((user) => (
                          <option key={user.id} value={user.username}>
                            {user.username}
                          </option>
                        ))}
                    </select>
                  </div>
                </>
              ) : (
                <FiltersBar
                  settingData={settingData}
                  handleDropdownChange={handleDropdownChange}
                  filters={filters}
                  studentList={studentList}
                  // validateInput={validateInput}
                  modifyMode={modifyMode}
                  disabled={false}
                  termPeriodData={termPeriodData}
                  termId={termId}
                  currentPeriod={currentPeriod}
                />
              )}
            </div>
            {activeMenu?.menu_name?.includes("Certificate") ? (
              <div className="d-flex justify-content-end flex-wrap mb-3 mt-2">
                {activeMenu?.menu_name?.includes("graduation") && (
                  <div
                    style={{ width: "160px", paddingTop: "2px" }}
                    className="text-center"
                  >
                    <select
                      className="form-control mt-1"
                      name="schoolStage"
                      onChange={handleSelectSchoolStage}
                      value={interComponentData?.schoolStage || ""}
                      disabled={noPermission || beforePrint}
                    >
                      <option value="">과정선택</option>
                      {graduationCertificateCustomContents?.schoolStageAll && (
                        <option value="all">전체</option>
                      )}
                      <option value="elementary">초등</option>
                      <option value="middle">중등</option>
                      <option value="high">고등</option>
                    </select>
                  </div>
                )}

                {beforePrint && (
                  <div style={{ width: "160px" }} className="text-center">
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={() => {
                        handlePrint(null, () => contentToPrint.current);
                      }}
                      // disabled={modifyMode}
                    >
                      인쇄로 발급확정
                    </button>
                  </div>
                )}
                <div style={{ width: "100px" }} className="me-1 text-center">
                  {!beforePrint && (
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={() => {
                        handleCreateCertificateHistory();
                      }}
                      disabled={
                        disabled ||
                        (activeMenu?.menu_name === "graduationCertificate" &&
                          interComponentData?.canIssueGraduationCertificate !==
                            true)
                      }
                    >
                      {t("admin.certificate.request") || "발급신청"}
                    </button>
                  )}
                  {beforePrint && (
                    <button
                      className="btn btn-warning"
                      type="button"
                      onClick={() => {
                        handleDeleteCertificateHistory();
                      }}
                      disabled={disabled}
                    >
                      발급취소
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-end flex-wrap mb-3 mt-2">
                <div style={{ width: "100px" }} className="me-1 text-center">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={handleModifyMode}
                    name={modifyMode ? "modifyOn" : "modifyOff"}
                  >
                    {modifyMode
                      ? t("teacher.printingRelated.modifyOff") || "수정해제"
                      : t("teacher.printingRelated.modifyOn") || "수정모드"}
                  </button>
                </div>

                <div style={{ width: "70px" }} className="me-1 text-center">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={() => {
                      handlePrint(null, () => contentToPrint.current);
                    }}
                    // disabled={modifyMode}
                  >
                    {t("common.labels.print") || "인쇄"}
                  </button>
                </div>
              </div>
            )}

            <div
              id="officialDocumentPrintArea"
              className="d-flex justify-content-center print-page"
              ref={contentToPrint}
            >
              <div className="" style={{ width: "210mm" }}>
                {/* 워터마크 */}
                {activeMenu?.menu_name?.includes("Certificate") && (
                  <div className={styles.watermark}>
                    {t("admin.certificate.preview") || "미리보기"}
                  </div>
                )}

                <div
                  colSpan="1"
                  className="p-2"
                  style={{
                    maxWidth: "200mm",
                    fontFamily: styleSettings.fontFamily
                      ? styleSettings.fontFamily
                      : "",
                  }}
                >
                  {styleSettings?.outLine &&
                  Object.keys(styleSettings.outLine).length > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "190mm",
                          height: "240mm",
                          maxWidth: "100%",
                          margin: "70px 70px 50px 70px",
                          ...styleSettings.outLine,
                        }}
                      >
                        {!isLoading &&
                          componentsToFormsData &&
                          componentsToFormsData.map((item, index) => (
                            <DynamicComponentsRenderer
                              components={item.components}
                              customizedContents={item.customized_contents}
                              keyData={keyData}
                              setIsLoadingModal={setIsLoadingModal}
                              key={`${item.id}-${item.order}-${index}`}
                              componentsToFormId={item.id}
                              modifyMode={modifyMode}
                              styleSettings={styleSettings}
                              interComponentData={interComponentData}
                              setInterComponentData={setInterComponentData}
                            />
                          ))}
                      </div>
                    </div>
                  ) : (
                    !isLoading &&
                    componentsToFormsData &&
                    componentsToFormsData.map((item, index) => (
                      <DynamicComponentsRenderer
                        components={item.components}
                        customizedContents={item.customized_contents}
                        keyData={keyData}
                        setIsLoadingModal={setIsLoadingModal}
                        key={`${item.id}-${item.order}-${index}`}
                        componentsToFormId={item.id}
                        modifyMode={modifyMode}
                        styleSettings={styleSettings}
                        interComponentData={interComponentData}
                        setInterComponentData={setInterComponentData}
                      />
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modifyMode && (
        <div className="col-12 col-md-2">
          <RightControlSidebar
            styleSettings={styleSettings}
            handleStyleSettings={handleStyleSettings}
          />
        </div>
      )}
    </div>
  );
}
